// First-touch attribution only; no names, answers or sensitive URL parameters are collected.
export function acquisitionForDraft() {
  const saved = sessionStorage.getItem("nxt_acquisition");
  if (saved) {
    try { return JSON.parse(saved); } catch { sessionStorage.removeItem("nxt_acquisition"); }
  }
  const params = new URLSearchParams(window.location.search);
  let host = "";
  if (document.referrer) {
    try { const ref = new URL(document.referrer); if (ref.hostname !== window.location.hostname) host = ref.hostname; } catch { /* Invalid browser referrer has no attribution. */ }
  }
  const utm = (params.get("utm_source") || "").trim().slice(0, 80).toLowerCase();
  const result = { source: utm || (host ? `referral:${host}`.slice(0, 80) : "Direct / no campaign"), medium: (params.get("utm_medium") || "").slice(0, 80), campaign: (params.get("utm_campaign") || "").slice(0, 80) };
  sessionStorage.setItem("nxt_acquisition", JSON.stringify(result));
  return result;
}
